const data = [
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832637,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 200000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832638,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832639,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832640,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832641,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832642,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832643,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832644,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832645,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832646,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832647,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832648,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
  {
    paymentSource: {},
    activityLogs: [],
    orderId: 17832649,
    name: 'John Brown',
    phone: '085212317366',
    userId: 91872653,
    createdAt: '2018-01-01T10:00:00',
    expiredAt: '2018-01-01T13:00:00',
    amount: 300000,
    bankName: 'BCA',
    bankNo: 76354654565,
    bankAccount: 'Dewi Budjana',
    status: 'Pending',
  },
]

export const statuses = {
  pending: 'Pending',
  confirmed: 'Confirmed',
  paid: 'Paid',
  executing: 'Executing',
  succeeded: 'Succeeded',
  expired: 'Expired',
  failed: 'Failed',
  // readytorefund: 'Ready To Refund',
  refunded: 'Refunded',
}

export const destBanks = {
  bca: 'BCA',
  mandiri: 'Mandiri',
  bni: 'BNI',
  cimb: 'CIMB Niaga',
  bri: 'BRI',
  btpn: 'Jenius',
  dbs: 'DigiBank',
}

export const bankCodeMapping = {
  jenius: 'btpn',
  bca: 'bca',
  mandiri: 'mandiri',
  bni: 'bni',
  cimbniaga: 'cimb',
  bri: 'bri',
  digibank: 'dbs',
}

export const originBanks = {
  bca: 'BCA',
  mandiri: 'Mandiri',
  bni: 'BNI',
  bri: 'BRI',
}


export default data



// WEBPACK FOOTER //
// src/pages/order/data.js